export const  //CONNECT = 'CONNECT',
      CONNECTING = 'CONNECTING',
      CONNECTED = 'CONNECTED',
      SOCKET_RECONNECTION_ERROR = 'SOCKET_RECONNECTION_ERROR',
      FAILED_CONNECTION = 'FAILED_CONNECTION',
      DISCONNECTED = 'DISCONNECTED',
      //////////////////////////////////
      SEND_ACTIVITY = 'SEND_ACTIVITY',
      UPDATE_ACTIVITY = 'UPDATE_ACTIVITY',
      RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY',
      RECEIVE_NEW_INTERACTION = 'RECEIVE_NEW_INTERACTION',
      RECEIVE_UPDATED_INTERACTION = 'RECEIVE_UPDATED_INTERACTION',
      RECEIVE_NOTICED_INTERACTION = 'RECEIVE_NOTICED_INTERACTION',
      RECEIVE_TAKEOVER_INTERACTION = 'RECEIVE_TAKEOVER_INTERACTION',
      RESEND_ACTIVITY = 'RESEND_ACTIVITY',
      ADD_MESSAGE = 'ADD_MESSAGE',
      SCROLL_TO_TOP = 'SCROLL_TO_TOP',
      SCROLL_TO_BOTTOM = 'SCROLL_TO_BOTTOM',
      FINISH_SCROLL_TO_BOTTOM = 'FINISH_SCROLL_TO_BOTTOM',
      FINISH_SCROLL_TO_TOP = 'FINISH_SCROLL_TO_TOP',

      RECEIVE_ACTIVITY_START = 'RECEIVE_ACTIVITY_START',
      SEND_ACTIVITY_START = 'SEND_ACTIVITY_START',
      REMOVE_BUSY_TYPING = 'REMOVE_BUSY_TYPING'

